// extracted by mini-css-extract-plugin
module.exports = {"container":"PolicyUpdatePage_container__2epPv","buttons":"PolicyUpdatePage_buttons__17SeG","header":"PolicyUpdatePage_header__E12Jz","help":"PolicyUpdatePage_help__ZxpUL"};